import React, { Component } from 'react'
import HttpServices from '../../../../utils/Http.services'
import { checkTranslation, imageAddress, translate } from '../../../../utils/useful'
import ButtonAnimated from '../../../buttons/ButtonAnimated'
import { getBoundingClientRect } from '../../../../utils/functions'
import CustomLoader from '../../../CustomLoader'

export default class AddMembers extends Component {
    state = {
        contactsList: [],
        selectedList: [],
        search: '',
        selected: 0,
        checkBox: {},
        searchBoxHeight: 51.2,
    }



    search = (event) => {

        this.setState({ search: event.target.value }, () => {
            let contactsListFiltered = this.state.contactsList.filter((e) =>
                e.fullname.toLowerCase().includes(this.state.search.toLowerCase())
            )
            this.setState({ contactsListFiltered }, () => {
                console.log("contactlist", contactsListFiltered)
            })
        })
    }

    componentDidMount = () => {
        console.log('here111')
        let body = {}
        this.setState({ isLoadingData: true })

        HttpServices.request('searchHubs', body, (fetchResult, fetchError) => {

            // console.log(fetchResult)
            this.setState({ isLoadingData: false })
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }

            this.setState({ contactsList: fetchResult.info, contactsListFiltered: fetchResult.info }, () => {

            })
        })
    }

    selectContact = (prop) => {
        let searchBox = this.searchBox
        let list = this.list
        let selectedList = this.state.selectedList
        if (selectedList.includes(prop._id)) {
            let index = selectedList.indexOf(prop._id)
            selectedList.splice(index, 1)
        }
        else {
            selectedList.push(prop._id)
        }
        this.setState({ selectedList }, () => {
            searchBox.style.height = 'auto';
            searchBox.style.height = (searchBox.clientHeight) + "px";
            let height = getBoundingClientRect(searchBox).height
            list.style.height = 'auto';
            list.style.height = (list.clientHeight) + "px";
            let listHeight = getBoundingClientRect(list).height
            searchBox.scrollTo({
                top: listHeight,
                behavior: 'smooth'
            })
            this.setState({ searchBoxHeight: height })
        })
    }

    changeValue = (key, value, cb) => {
        this.setState({ [key]: value }, () => {
            if (cb) {
                cb()
            }
        })
    }

    openSidebar = () => {
        this.sidebarView.openSidebar()
    }

    openFirstView = () => {
        this.firstView.showView()
    }

    openMemberView = () => {
        this.memberView.showView()
    }

    render() {
        return (
            <div className='w-100 h-100'>
                {/* <div className='flexc pb-2' style={{  }}> */}
                <div className='px-2 py-3' style={{}}>
                    <div className='flexcb' style={{}}>
                        <button className='flexc' onClick={() => this.props.changeStage("manage")}>
                            <img width={20} src='/assets/icons/angle-right-black.svg' className='rtl-button' style={{ transform: 'rotate(180deg)' }} />
                            <p className='text-bold text-small px-1' style={{}}>{translate('messenger.Add Members')}</p>
                        </button>
                        <div className='flexc'>
                            <div className="px-1">
                                <ButtonAnimated
                                    onClick={() => this.props.changeStage('info')}
                                    title={translate('messenger.Discard')}
                                    bg={'linear-gradient(to right, #eee, #eee)'}
                                    textColor={'#777'}
                                    width={'100%'}
                                />
                            </div>
                            <ButtonAnimated
                                iconwidth='24px'
                                onClick={() => { }}
                                title={translate('messenger.Save')}
                                icon='/assets/icons/angle-right-white2.svg'
                                textColor={'#fff'}
                                bg={this.props.background ?? ' linear-gradient(90deg, #0085ff, #0085ff)'}
                                width={'100%'}
                            />
                        </div>
                    </div>
                    {/* <div>
                            <button className='mx-2 hover-btn' onClick={() => this.props.changeStage('info')}>
                                <p style={{ color: "#FF0000" }}>{translate('messenger.Discard')}</p>
                            </button>
                            <button className='mx-2'>
                                <p style={{ color: "#007AFF" }}>{translate('messenger.Save')}</p>
                            </button>
                        </div> */}
                </div>
                {/* </div> */}
                {!this.props.isLoader ? (
                    <>
                        <div ref={el => this.searchBox = el} className="mx-2 py-2 scroll-no-scrollbar" style={{ borderTop: "1px solid #eee", height: this.state.searchBoxHeight, maxHeight: '80px', overflow: 'auto', }}>
                            <div className='flexc' style={{ backgroundColor: '#f6f6f6', borderRadius: 10, flexWrap: 'wrap', }}>
                                <div ref={el => this.list = el} className='flexc' style={{ flexWrap: 'wrap' }}>
                                    {Array.isArray(this.state.contactsList) && this.state.contactsList.map((item, index) => {
                                        return (
                                            <>
                                                {Array.isArray(this.state.selectedList) && this.state.selectedList.map((select, sindex) => {
                                                    if (item._id == select) {
                                                        return (
                                                            <div className='br-100 flexcc px-2 mx-1 my-1' style={{ background: ' linear-gradient(90deg, #0085ff, #0085ff)' }}>
                                                                <p className='font-size-12 white px-2 py-1' style={{ whiteSpace: 'nowrap' }}>{item.fullname}</p>
                                                                <button className="flexcc" onClick={() => this.selectContact(item)}>
                                                                    <img src="/assets/icons/remove-white.svg" width={10} />
                                                                </button>
                                                            </div>
                                                        )
                                                    }
                                                })}
                                            </>
                                        )
                                    })}
                                </div>
                                <input onChange={e => this.search(e)} value={this.state.search} className="py-2 px-2 w-100" placeholder={translate('messenger.Search')} style={{ backgroundColor: 'transparent', border: 'none' }} />
                            </div>
                        </div>
                        <div className='br-10 d-flex flex-column px-2 pb-1 scroll-no-scrollbar' style={{ height: `calc(100% - (${66 + this.state.searchBoxHeight}px)` }} >
                            {this.state.contactsListFiltered?.map((prop) => {
                                return (
                                    <button onClick={() => this.selectContact(prop)}>
                                        <div className='flexcb w-100 py-2 hover-gray2 br-5 px-2'>
                                            <div className='flexc'>
                                                <img className='br-50' style={{ objectFit: "cover" }} width={30} height={30} src={imageAddress(prop?.image, 'profile')} />
                                                <div className='mld-2'>
                                                    <p>{checkTranslation(prop.fullname)}</p>
                                                    <p className="" style={{ color: '#567', fontSize: 11, textAlign: 'start' }}>{this.props.language == 'fa' ? prop?.username + '@' : '@' + prop?.username}</p>
                                                </div>
                                            </div>
                                            <div className=''>
                                                <img className='flexcc' width={20} height={20} src={this.state.selectedList.includes(prop._id) ? '/assets/icons/messenger/check-fill.svg' : '/assets/icons/messenger/check.svg'} />
                                            </div>
                                        </div>
                                    </button>
                                )
                            })}
                        </div>
                    </>
                ) : (
                    <div className='h-100 flexcc'>
                        <CustomLoader color={"#007aff"} isLoading={true} />
                    </div>
                )}
                {/* <div style={{ position: "fixed", bottom: 10, right: 10 }}>
                    <button className='mx-2 blue-btn px-3 py-1 br-5' onClick={() => this.createGroup()}>
                        <p style={{ color: "#fff", fontSize: 14 }}>Save</p>
                    </button>
                </div> */}
            </div>
        )
    }
}
